module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"howToNotice":"Что делать после импорта кандидатов","call":"Звонок роботом"}}')
  delete Component.options._Ctor
}
